import routes from 'routes/forms'

const Forms = () =>
  routes

export default Forms
